export default __webpack_public_path__ + "static/media/delete_icon.e301bd97.svg";